function measuresParser(measure) {
  return { value: measure?.value ?? '?', unit: measure?.unit ?? '?' };
}

export default measuresParser;
